module.exports = __webpack_public_path__ + "static/media/utpl-01.80c4dd00.png";